<template>
    <ai-popup
        title="Создать новую массовую блокировку"
        :bottom-buttons-enabled="true"
        width="60%"
        height="75%"
        v-model:visible="state.massLocksPopupVisible"
        @submit-click="saveClick"
        @close-popup="closePopup"
    >
        <div class="h-[100%] flex flex-col gap-3">
            <div class="grid grid-cols-2 gap-2">
                <dx-select-box
                    v-model="massLock.typeLockId"
                    :data-source="lockReasons"
                    value-expr="id"
                    display-expr="name"
                    width="100%"
                    label-mode="outside"
                    label="Тип блокировки"
                />
                <dx-text-box
                    v-model="massLock.reason"
                    width="100%"
                    label-mode="outside"
                    label="Описание" />
                <dx-date-box
                    v-model="massLock.dateBeg"
                    type="datetime"
                    label-mode="outside"
                    label="Дата начала" />
                <dx-date-box v-model="massLock.dateEnd" type="datetime" label-mode="outside"
                             label="Дата окончания"></dx-date-box>
            </div>
            <ai-grid-ro-wrapper
                class="h-full"
                :meta="meta"
                :dataSource="props.users"
                :show-grid-footer="false"
                :to-remove-toolbar-items-names="toRemoveToolbarItemsNames"
                :hasnt-route="true"
            />
        </div>
    </ai-popup>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { DxSelectBox, DxTextBox, DxDateBox } from 'devextreme-vue';
import AiGridRoWrapper from '@/components/wrappers/ai-grid-ro-wrapper.vue';
import AiPopup from '@/components/ai-popup/ai-popup.vue';

import { getLockReasons, lockUsers } from '@/service/admin-service.js';
import usersLocalStore from '@/views/administration/users/store.js';

import activeUserImg from '../../../../public/assets/active-user.svg';
import deletedUserImg from '../../../../public/assets/deleted-user.svg';
import lockedUserImg from '../../../../public/assets/locked-user.svg';

import { dxUiNotify } from '@/utils/dx-helper';

const { state, USER_STATUS } = usersLocalStore;

const emit = defineEmits(['refreshUserGrid']);

const toRemoveToolbarItemsNames = ['refresh', 'choice'];
const lockReasons = ref();
const refreshUserGrid = ref(false);
const massLock = reactive({
    userIds: [],
    typeLockId: null,
    dateBeg: null,
    dateEnd: null,
    reason: null,
});

onMounted(async () => {
    lockReasons.value = await getLockReasons();
    massLock.userIds = props.users.map(user => user.id);
});

const props = defineProps({
    users: {
        type: Array,
        default: () => [],
    },
});

const saveClick = async () => {
    const response = await lockUsers(massLock.userIds, massLock.typeLockId, massLock.dateBeg, massLock.dateEnd, massLock.reason);
    if (response.success) {
        refreshUserGrid.value = true;
        closePopup();
        dxUiNotify('Пользователи успешно заблокированы', 'success');
    } else {
        dxUiNotify('Ошибка при блокировке пользователей', 'error');
    }
};

const closePopup = () => {
    if (refreshUserGrid.value) emit('refreshUserGrid');
    state.massLocksPopupVisible = false;
};

const meta = {
    keyExpr: 'id',
    wordWrapEnabled: true,
    scrollingMode: 'standart',
    focusedRowEnabled: true,
    selectionMode: 'none',
    autoLoadData: false,
    api: {
        select: '',
    },
    columns: [
        {
            dataField: 'id',
            caption: 'ID',
            visible: false,
            dataType: 'number',
        },
        {
            dataField: 'user_login',
            caption: 'Логин',
            dataType: 'string',
        },
        {
            dataField: 'fio',
            caption: 'ФИО',
            dataType: 'string',
        },
        {
            dataField: 'status',
            caption: 'Статус',
            cellTemplate: (cellElement, cellInfo) => {
                const imgSrc = cellInfo.value === USER_STATUS.ACTIVE
                    ? activeUserImg
                    : cellInfo.value === USER_STATUS.DELETED
                        ? deletedUserImg
                        : lockedUserImg;
                const imgElement = document.createElement('img');
                imgElement.src = imgSrc;
                imgElement.style.width = '15px';
                imgElement.style.height = '15px';
                cellElement.appendChild(imgElement);
            },
        },
        {
            dataField: 'type_name',
            caption: 'Тип учетной записи',
            dataType: 'string',
        },
    ],
};
</script>

<style lang="scss">
.custom-user-popup-buttons {
    .dx-button-text {
        text-transform: none !important;
    }

    .save-button.dx-button {
        width: 214px;
        height: 40px;
        background-color: #286eb6;
        color: white;
        border-radius: 5px;
    }

    .save-button.dx-button.dx-state-hover {
        background-color: #0b4c8c;
    }

    .cancel-button.dx-button {
        width: 214px;
        height: 40px;
        background-color: #cbe1f7;
        color: #031425;
    }

    .cancel-button.dx-button.dx-state-hover {
        background-color: #b6cade;
    }
}
</style>
